import { render, staticRenderFns } from "./ElectedList.vue?vue&type=template&id=065a9426&scoped=true"
import script from "./ElectedList.vue?vue&type=script&lang=js"
export * from "./ElectedList.vue?vue&type=script&lang=js"
import style0 from "./ElectedList.vue?vue&type=style&index=0&id=065a9426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065a9426",
  null
  
)

export default component.exports